import React, {useState} from "react";
import Chart from "react-apexcharts";

const TargetReality = () => {

    const chartOptions = {
        chart: {
          id: 'sales-chart',
          toolbar: {
            show: false,
          },
        },
        colors: ['#32CD32', '#FFD700'], // Colors for 'Reality Sales' and 'Target Sales'
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%', // Adjust the width of bars
            endingShape: 'rounded', // Gives rounded corners to the bars
          },
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        },
        yaxis: {
          title: {
            text: '',
          },
          min: 0,
          max: 15000, // Adjust the maximum for y-axis
          tickAmount: 5,
        },
        legend: {
          show: true, // We'll handle the legend below the chart
          position: 'bottom',
          markers: {
            fillColors: ['#32CD32', '#FFD700'], // Colors in the legend
          },
        },
        grid: {
          strokeDashArray: 3, // Gridline style
        },
        dataLabels: {
          enabled: false, // No data labels on the bars
        },
      };
    
      const chartSeries = [
        {
          name: 'Reality Sales',
          data: [8000, 9000, 7500, 8500, 10000, 12000, 9000],
        },
        {
          name: 'Target Sales',
          data: [9000, 10000, 8500, 9500, 11000, 13000, 12000],
        },
      ];
    
      return (
        <div>
          <Chart options={chartOptions} series={chartSeries} type="bar" height="220" />
        </div>
      );
}

export default TargetReality;